// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import md5 from 'js-md5'
import './plugins/element.js'
import './assets/css/global.css'
// import constant from './common/constant.js'
import axios from 'axios'
// element-ui的全部组件
import Element from 'element-ui'
// element-ui的css
import 'element-ui/lib/theme-chalk/index.css'
// import { error } from 'shelljs'

// 使用elementUI
Vue.use(Element)
// 使用md5获取摘要
Vue.prototype.$md5 = md5

Vue.config.productionTip = false

axios.defaults.timeout = 50000
axios.defaults.withCredentials = true
axios.defaults.crossDomain = true
axios.defaults.headers.common['Access-Control-Allow-Origin'] = true
axios.defaults.headers.post['Content-Type'] = 'application/json'
if (window.location.hostname === 'localhost') {
  axios.defaults.baseURL = 'http://localhost:9001/api/manager'
} else {
  axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/api/v1'
}
// axios.defaults.baseURL = 'http://we-technology.top/api/v1'
axios.interceptors.request.use(config => {
  // console.log('config.url========' + config.url)
  // var token = window.sessionStorage.getItem('token')
  // console.log('config.token========' + token)
  var isLogin = config.url.includes('login')
  if (!isLogin) {
    config.headers.Authorization = window.sessionStorage.getItem('token')
  }
  return config
})

axios.interceptors.response.use(function (response) {
  return response
}, error => {
  let response = error.response
  const status = response.data.code
  if (status === -11) {
    // 判断状态码是异常 跳转到登录
    router.push('/login')
  }
  return {
    body: {
      data: '',
      error: '请重新登录'
    }
  }
})

// Vue.prototype.$constant = constant
Vue.prototype.$http = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js